<script
  src="https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&libraries=geometry"></script>

<template>
  <div>
    <div class="mb-3" style="display: flex; align-items: center; gap: 10px;">
      <!-- Back button -->
      <div style="display: flex; align-items: center; cursor: pointer" @click="$router.go(-1)">
        <i class="fas fa-chevron-left mr-2" style="width: 4px; height: 8px; font-size: 8px; line-height: 8px; padding-right: 10px;"></i>
        <span style="font-size: 16px; font-family: 'DM Sans', sans-serif;">Back</span>
      </div>

      <!-- Divider -->
      <p style="font-size: 20px; margin: 0;">|</p>

      <!-- Title -->
      <div style="display: flex; align-items: center; font-size: 16px; font-weight: bold; font-family: 'DM Sans', sans-serif;">
        QR Journey
      </div>
    </div>

    <div class="page-wrapper">
      <div class="page-content">
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="card radius-10 timeline-card">
              <div class="card-header py-3" style="background-color: #FFFFFF;">
                <div v-if="productDetail">
                  <p class="mb-0"
                    style="font-family: 'Proxima Nova', sans-serif; font-weight: 600; font-style: normal; font-size: 13px; color: #383838;">
                    {{ productDetail.product_name }}
                  </p>
                  <p class="mb-0"
                    style="font-family: 'Proxima Nova', sans-serif; font-weight: 400; font-style: normal; font-size: 12px; color: #BEBEBE;">
                    {{ serialNumber }}
                  </p>
                </div>
              </div>
              <div class="card-body overflow-auto">
                <div class="row">
                  <div class="col-md-12">
                    <ul class="vertical-timeline">
                      <!-- <li v-for="(marker, index) in journeyData" :key="index" :class="['vertical-timeline-item', { 'last-item': index === journeyData.length - 1 }, ] " > -->

                      <li
                        v-for="(marker, index) in journeyData"
                        :key="index"
                        :class="['vertical-timeline-item', { 'last-item': index === journeyData.length - 1 }]"
                        :style="{ '--timeline-color': timelineColors[index] || '#695bfc' }"
                      >
                        <div class="timeline-content">
                          <div class="timeline-date text-soft-grey" v-if="index + 1 <= journeyData.length - 1">{{
                            journeyData[index + 1].distance }} Km</div>
                          <div class="d-flex justify-content-between">
                            <div class="col-10">
                              <div class="d-flex justify-content-start">
                                <div>
                                  <h5 class="timeline-title font-12 mb-2" style="float: left">{{ marker.nama_provinsi }}
                                  </h5>
                                </div>
                                <div>
                                  <p class="text-soft-grey mb-2 ps-2 ml-1 text-muted"
                                    style="font-size: 9px; padding-top: 4px">{{ marker.scan_date }}</p>
                                </div>
                              </div>
                              <div class="timeline-description">
                                <p class="font-10 mb-0">
                                  {{ marker.status === "fake" ? "Deteksi dicurigai" : "Deteksi" }}
                                  <span :class="marker.status === 'fake' ? 'text-danger' : 'text-success'">{{
                                    marker.status === "fake" ? "palsu" : "asli" }}</span>
                                  via
                                  <span class="text-primary">{{ marker.device }}</span>
                                  di perangkat
                                  <span class="text-primary">{{ marker.phone_model }}</span>
                                </p>
                              </div>
                            </div>
                            <div class="col text-center">
                              <svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer mapsClick"
                                @mouseover="handleMouseOver(index)" width="36" height="35" viewBox="0 0 36 35">
                                <g id="Group_2848" data-name="Group 2848" transform="translate(-331 -230)">
                                  <g id="Rectangle_120" data-name="Rectangle 120" transform="translate(331 230)"
                                    fill="#fff" stroke="#e8e8e8" stroke-width="1">
                                    <rect width="36" height="35" rx="5" stroke="none" />
                                    <rect x="0.5" y="0.5" width="35" height="34" rx="4.5" fill="none" />
                                  </g>

                                  <path id="Icon_awesome-map-marker-alt" data-name="Icon awesome-map-marker-alt"
                                    d="M6.364,18.532C1,10.751,0,9.952,0,7.093a7.093,7.093,0,1,1,14.185,0c0,2.86-1,3.658-6.364,11.439a.887.887,0,0,1-1.458,0Zm.729-8.484A2.955,2.955,0,1,0,4.137,7.093,2.955,2.955,0,0,0,7.093,10.048Z"
                                    transform="translate(341.907 238.043)"
                                    fill="#695BFC" />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-8 col-sm-12">
            <div class="sticky-md-top fixed-card z-index-0" style="top: 70px">
              <div id="map"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MapComponent from "./children/MapQrJourney.vue";

export default {
  metaInfo: {
    title: "QR Journey",
  },
  name: "App",
  // components: {
  //   MapComponent,
  // },
  data() {
    return {
      journeyData: null,
      map: null,
      markers: [],
      polyline: null,
      infoWindow: null,
      prevHoveredMarker: null,
      prevHoveredPosition: null,
      qrcode: this.$route.query.qrcode,
      serialNumber: this.$route.query.serial_number,
      provinces: [],
      productDetail: null,
      timelineColors: [],

      showFloatingCard: false,
      lastScrollPosition: 0,
    };
  },
  mounted() {
    this.initMap();
    this.loadQrcodes();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    async initMap() {
      const mapOptions = {
        center: { lat: -2.5489, lng: 118.0149 },
        zoom: 5,
        mapTypeControl: false,
        streetViewControl: false,
      };

      this.map = new google.maps.Map(document.getElementById("map"), mapOptions);
      this.infoWindow = new google.maps.InfoWindow();

      const bounds = new google.maps.LatLngBounds();

      this.provinces.forEach((city, index) => {
        const marker = new google.maps.Marker({
          position: { lat: city.lat, lng: city.lng },
          map: this.map,
          title: city.nama_provinsi,
          icon: {
            // url: city.status === 'genuine' ? require('@/assets/maps_green_marker.png') : require('@/assets/maps_green_marker.png'),
            url: city.status === "genuine" ? "data:image/svg+xml;charset=UTF-8," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="35.815" height="47.753" viewBox="0 0 35.815 47.753"><path id="Icon_awesome-map-marker-alt" data-name="Icon awesome-map-marker-alt" d="M16.067,46.79C2.515,27.144,0,25.128,0,17.907a17.907,17.907,0,0,1,35.815,0c0,7.22-2.515,9.236-16.067,28.882a2.239,2.239,0,0,1-3.681,0Zm1.84-21.421a7.461,7.461,0,1,0-7.461-7.461A7.461,7.461,0,0,0,17.907,25.369Z" fill="#0AC36E"/></svg>') : "data:image/svg+xml;charset=UTF-8," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="35.815" height="47.753" viewBox="0 0 35.815 47.753"><path id="Icon_awesome-map-marker-alt" data-name="Icon awesome-map-marker-alt" d="M16.067,46.79C2.515,27.144,0,25.128,0,17.907a17.907,17.907,0,0,1,35.815,0c0,7.22-2.515,9.236-16.067,28.882a2.239,2.239,0,0,1-3.681,0Zm1.84-21.421a7.461,7.461,0,1,0-7.461-7.461A7.461,7.461,0,0,0,17.907,25.369Z" fill="#D93636"/></svg>'),

            scaledSize: new google.maps.Size(25, 30),
          },
        });

        this.markers.push(marker);
        bounds.extend(marker.getPosition());

        marker.addListener("mouseover", () => {
          const targetMarker = marker;
          this.map.setZoom(8, { animate: true });
          this.map.setCenter(targetMarker.getPosition());

          let status = "#0AC36E";
          let statusText = "Deteksi Asli";
          if (city.status === "fake") {
            status = "#D93636";
            statusText = "Dicurigai Palsu";
          }

          let content = '<table style="width:190px; font-family: \'Proxima Nova\', sans-serif;">';
          content += '<tr class="p-2"><td style="font-weight: 600; font-size: 12px; color: #393939;">' + city.name + '</td><td rowspan="2" style="font-weight: 400; font-size: 10px; color: #AFAFAF;">' + city.distance + " Km</td></tr>";
          content += '<tr class="p-2"><td class="my-auto" style="font-weight: 400; font-size: 10px; color:' + status + '">' + statusText + "</td></tr>";
          content += "</table>";

          this.infoWindow.setContent(content);
          this.infoWindow.open(this.map, targetMarker);

          if (this.polyline) {
            this.polyline.setMap(null);
          }
        });

        marker.addListener("mouseout", () => {
          const targetMarker = marker;
          this.map.setZoom(5, { animate: true });
          this.map.setCenter(targetMarker.getPosition());
          this.infoWindow.close();
        });
      });

      this.map.fitBounds(bounds);

      // const listItems = document.querySelectorAll(".mapsClick");

      // listItems.forEach((item, index) => {
      //  item.addEventListener("mouseover", () => {
      //         const targetMarker = this.markers[index];
      //         // const targetPosition = targetMarker.getPosition();
      //         // const prevMarkerPosition = index > 0 ? this.markers[index - 1].getPosition() : this.markers[0].getPosition();

      //         const bounds = new google.maps.LatLngBounds();

      //         this.markers.forEach(marker => {
      //             marker.setVisible(false);
      //         });

      //         for (let i = 0; i <= index; i++) {
      //             this.markers[i].setVisible(true);
      //             bounds.extend(this.markers[i].getPosition());
      //         }

      //         this.map.fitBounds(bounds);

      //         let status = 'success';
      //         let statusText = 'Deteksi Asli';
      //         if (this.provinces[index]['status'] === 'fake') {
      //             status = 'danger';
      //             statusText = 'Dicurigai palsu';
      //         }

      //         let content = '<table style="width:190px">';
      //         content += '<tr class="p-2"><td class="fw-bold">' + this.provinces[index]['name'] + '</td><td rowspan="2" style="color:#AFAFAF">' + this.provinces[index]['distance'] + ' KM</td></tr>';
      //         content += '<tr class="p-2"><td class="my-auto text-' + status + '">' + statusText + '</td></tr>';
      //         content += '</table>';

      //         this.infoWindow.setContent(content);
      //         this.infoWindow.open(this.map, targetMarker);

      //         google.maps.event.addListener(this.map, 'click', () => {
      //             if (this.infoWindow != null) {
      //                 this.infoWindow.close();
      //             }
      //         });

      //         if (this.polyline) {
      //             this.polyline.setMap(null);
      //         }

      //         const polylineCoordinates = this.markers.slice(0, this.markers.indexOf(targetMarker) + 1).map(m => {
      //             return { lat: m.position.lat(), lng: m.position.lng() };
      //         });

      //         this.polyline = new google.maps.Polyline({
      //             path: polylineCoordinates,
      //             geodesic: true,
      //             strokeColor: "#695BFC",
      //             strokeOpacity: 1.0,
      //             strokeWeight: 4,
      //             map: this.map,
      //         });
      //     });
      // });
    },

    async handleMouseOver(index) {
      const targetMarker = this.markers[index];

      const bounds = new google.maps.LatLngBounds();

      this.markers.forEach((marker) => {
        marker.setVisible(false);
      });

      for (let i = 0; i <= index; i++) {
        this.markers[i].setVisible(true);
        bounds.extend(this.markers[i].getPosition());
      }

      this.map.fitBounds(bounds);

      let status = "#0AC36E";
      let statusText = "Deteksi Asli";
      if (this.provinces[index]["status"] === "fake") {
        status = "#D93636";
        statusText = "Dicurigai Palsu";
      }

      let content = '<table style="width:190px; font-family: \'Proxima Nova\', sans-serif;">';
      content += '<tr class="p-2"><td style="font-weight: 600; font-size: 12px; color: #393939;">' + this.provinces[index]["name"] + '</td><td rowspan="2" style="font-weight: 400; font-size: 10px; color: #AFAFAF;">' + this.provinces[index]["distance"] + " Km</td></tr>";
      content += '<tr class="p-2"><td class="my-auto" style="font-weight: 400; font-size: 10px; color:' + status + '">' + statusText + "</td></tr>";
      content += "</table>";

      this.infoWindow.setContent(content);
      this.infoWindow.open(this.map, targetMarker);

      google.maps.event.addListener(this.map, "click", () => {
        if (this.infoWindow != null) {
          this.infoWindow.close();
        }
      });

      if (this.polyline) {
        this.polyline.setMap(null);
      }

      const polylineCoordinates = this.markers.slice(0, this.markers.indexOf(targetMarker) + 1).map((m) => {
        return { lat: m.position.lat(), lng: m.position.lng() };
      });

      this.polyline = new google.maps.Polyline({
        path: polylineCoordinates,
        geodesic: true,
        strokeColor: "#695BFC",
        strokeOpacity: 1.0,
        strokeWeight: 4,
        map: this.map,
      });
    },

    async loadQrcodes() {
      try {
        let response = await this.$http.get("/dashboard/qr-journey?qrcode=" + this.qrcode);
        this.journeyData = response.data.data;
        let firstData = this.journeyData[0];
        // console.log(firstData);

        this.provinces = this.journeyData.map((item) => ({
          name: item.nama_provinsi,
          lat: item.lat,
          lng: item.lng,
          status: item.status,
          distance: item.distance,
        }));

        this.generateTimelineColors();
        this.initMap();

        this.productDetail = {
          product_name: firstData ? firstData.product_name : "Not Found",
          qrcode: firstData ? firstData.qrcode : "Not Found",
        };
      } catch (err) {
        console.log(err);
      }
    },

    handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition > this.lastScrollPosition) {
        this.isFloatingCardFixed = true;
      } else {
        this.isFloatingCardFixed = false;
      }
      this.lastScrollPosition = currentScrollPosition;
    },

    generateTimelineColors() {
      if (!this.journeyData || !this.journeyData.length) {
        this.timelineColors = [];
        return;
      }

      const baseSequence = ["#267CE5", "#03C3FB", "#03C3FB", "#F7B731"];
      const palette = ["#267CE5", "#03C3FB", "#F7B731"];

      const colors = [];
      this.journeyData.forEach((_, index) => {
        const previousColor = colors[index - 1] || null;
        let color;

        if (index < baseSequence.length) {
          color = baseSequence[index];
          if (previousColor && color === previousColor) {
            color = this.pickAlternativeColor(palette, previousColor);
          }
        } else {
          color = this.getRandomColorExcluding(palette, previousColor);
        }

        colors.push(color);
      });

      this.timelineColors = colors;
    },

    pickAlternativeColor(palette, excludeColor) {
      const alternative = palette.find((c) => c !== excludeColor);
      return alternative || palette[0];
    },

    getRandomColorExcluding(palette, excludeColor) {
      const availableColors = palette.filter((color) => color !== excludeColor);
      if (!availableColors.length) {
        return palette[0];
      }
      const randomIndex = Math.floor(Math.random() * availableColors.length);
      return availableColors[randomIndex];
    },
  },
};
</script>

<style scoped>
#map {
  height: 526px;
  width: 100%;
  border-radius: 8px;
}

.vertical-timeline {
  position: relative;
  padding: 0;
  margin: 0;
  list-style: none;
}

.vertical-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 41px;
  width: 2px;
  height: 100%;
  background: #ccc;
}

.vertical-timeline-item {
  position: relative;
  margin-bottom: 40px;
}

.vertical-timeline-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 36px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--timeline-color, #695bfc);
  border: 2px solid #ccc;
}

.vertical-timeline-item .timeline-content {
  position: relative;
  /* padding-left: 10px; */
  padding-bottom: 20px;
  background: #ffff;
  border-radius: 4px;
  margin-left: 60px;
}

.vertical-timeline-item .timeline-content::before {
  content: "";
  position: absolute;
  top: 20px;
  right: -8px;
  width: 0;
  height: 0;
  /* border-top: 8px solid transparent;
  border-left: 8px solid #f5f5f5;
  border-right: 8px solid transparent;
  border-bottom: 8px solid transparent; */
}

.vertical-timeline-item .timeline-content .timeline-title {
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 15px;
}

.vertical-timeline-item .timeline-content .timeline-description {
  margin-bottom: 0;
  font-size: 11px;
}

.vertical-timeline-item .timeline-date {
  position: absolute;
  top: 110%;
  left: -100px;
  width: 110px;
  text-align: right;
  font-size: 10px;
  font-weight: 600;
  color: #777;
  transform: translateY(-50%);
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #ffff;
  border-radius: 4px;
  z-index: 1;
}

.vertical-timeline-item .timeline-content .map-icon {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  color: #777;
}

.leaflet-popup-close-button {
  display: none;
}

.gm-style-iw button.gm-ui-hover-effect {
  display: none !important;
}

.floating-card {
  position: fixed;
  top: -200px;
  width: 54%;
  height: auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: top 0.3s;
}

.floating-card.fixed {
  top: 50px;
}

.text-success {
  color: #28a745 !important;
}

.overflow-auto {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-height: 460px;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.overflow-auto::-webkit-scrollbar {
  display: none;
}

.timeline-card {
  border-radius: 8px;
  border: none;
}
</style>